module.exports = __webpack_public_path__ + "static/media/ic-popover-close.971bee7b.svg";